import React, { useState } from 'react';

const VehicleSpecs = ({ onSearch, onSave }) => {
  const [specs, setSpecs] = useState({
    brand: '',
    group: '',
    category: '',
    model: '',
    year: ''
  });

  const brands = ['تويوتا', 'نيسان', 'هوندا', 'هيونداي', 'كيا', 'مرسيدس', 'بي ام دبليو', 'أودي'];
  const groups = ['سيدان', 'دفع رباعي', 'كروس أوفر', 'هايبرد', 'كهربائية', 'تجارية'];
  const categories = ['اقتصادية', 'متوسطة', 'فاخرة', 'رياضية', 'عائلية'];
  const models = ['كامري', 'كورولا', 'لاندكروزر', 'هايلكس', 'راف فور', 'برادو'];
  const years = Array.from({ length: 30 }, (_, i) => (2024 - i).toString());

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSpecs({
      ...specs,
      [name]: value
    });
  };

  const handleSearch = () => {
    if (specs.brand && specs.model && specs.year) {
      onSearch('specs', specs);
    } else {
      alert('الرجاء اختيار البراند والموديل وسنة الصنع على الأقل');
    }
  };

  const handleSave = () => {
    if (specs.brand && specs.model && specs.year) {
      onSave(specs);
      alert('تم حفظ المواصفات بنجاح!');
    } else {
      alert('الرجاء اختيار البراند والموديل وسنة الصنع على الأقل للحفظ');
    }
  };

  return (
    <div>
      <p className="text-gray-600 mb-6 text-2xl">اختر مواصفات سيارتك للعثور على القطع المناسبة لها بدقة.</p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        <div>
          <label className="block text-gray-700 text-2xl font-semibold mb-2">البراند</label>
          <select
            name="brand"
            value={specs.brand}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-800 text-xl text-xl"
          >
            <option  className=" text-2xl " value="">اختر البراند</option>
            {brands.map(brand => (
              <option  className=" text-2xl " key={brand} value={brand}>{brand}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label className="block text-gray-700 text-2xl font-semibold mb-2">مجموعة السيارة</label>
          <select
            name="group"
            value={specs.group}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-800 text-xl"
          >
            <option  className=" text-2xl " value="">اختر المجموعة</option>
            {groups.map(group => (
              <option  className=" text-2xl " key={group} value={group}>{group}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label className="block text-gray-700 text-2xl font-semibold mb-2">الفئة</label>
          <select
            name="category"
            value={specs.category}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-800 text-xl"
          >
            <option  className=" text-2xl " value="">اختر الفئة</option>
            {categories.map(cat => (
              <option  className=" text-2xl " key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label className="block text-gray-700 text-2xl font-semibold mb-2">الموديل</label>
          <select
            name="model"
            value={specs.model}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-800 text-xl"
          >
            <option  className=" text-2xl " value="">اختر الموديل</option>
            {models.map(model => (
              <option  className=" text-2xl " key={model} value={model}>{model}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label className="block text-gray-700 text-2xl font-semibold mb-2">سنة الصنع</label>
          <select
            name="year"
            value={specs.year}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white text-gray-800 text-xl"
          >
            <option  className=" text-2xl " value="">اختر السنة</option>
            {years.map(year => (
              <option  className=" text-2xl " key={year} value={year}>{year}</option>
            ))}
          </select>
        </div>
        
        <div className="flex items-end">
          <div className="w-full space-y-3">
            <button
              className="w-full bg-gradient-to-r text-xl from-blue-900 to-indigo-700  text-white py-3 rounded-lg font-semibold hover:from-blue-900 hover:to-indigo-800 transition-all duration-300 shadow-md"
              onClick={handleSearch}
            >
              بحث حسب المواصفات
            </button>
            
            <button
              className="w-full bg-gradient-to-r text-xl from-green-500 to-green-600 text-white py-3 rounded-lg font-semibold hover:from-green-600 hover:to-emerald-700 transition-all duration-300 shadow-md"
              onClick={handleSave}
            >
              حفظ المواصفات
            </button>
          </div>
        </div>
      </div>
      
      {specs.brand && specs.model && specs.year && (
        <div className="bg-gradient-to-r from-green-50 to-green-50 border border-green-100 rounded-xl p-4 mb-6">
          <h3 className="font-semibold text-gray-800 mb-2 text-2xl">المواصفات المحددة:</h3>
          <div className="flex flex-wrap gap-3">
            {Object.entries(specs).map(([key, value]) => (
              value && (
                <div key={key} className="bg-white px-4 py-2 rounded-lg shadow-sm">
                  <span className="text-gray-600 text-2xl">{getLabel(key)}:</span>
                  <span className="font-semibold text-gray-800 mr-2 text-2xl"> {value}</span>
                </div>
              )
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const getLabel = (key) => {
  const labels = {
    brand: 'البراند',
    group: 'المجموعة',
    category: 'الفئة',
    model: 'الموديل',
    year: 'سنة الصنع'
  };
  return labels[key] || key;
};

export default VehicleSpecs;